import React from "react";
import DragDrop from "./DragDrop2";

export default class DragDemo extends React.Component {
    constructor(props) {
        super(props);
        this.data = [
            {
                key: "0",
                name: "test1",
            },
            {
                key: "1",
                name: "test2",
            },
            {
                key: "2",
                name: "test3",
            },
            {
                key: "3",
                name: "test1",
            }
        ]
    }

    onMove = (a, b) => {
        // console.log(a, b)
    }

    render() {
        return (
            <React.Fragment>
                <DragDrop.Container>
                    <div
                        style={{
                            marginBottom: "12px",
                            overflowY: "auto",
                            border: "1px solid #D2D8DE",
                            borderRadius: "5px",
                        }}
                    >
                        {
                            _.map(this.data, (it, index) => {
                                return (
                                    <DragDrop.Item
                                        key={it.key}
                                        move={this.onMove}
                                        index={index}
                                        group="1"
                                        style={{
                                            height: 39,
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "0 16px",
                                        }}
                                        renderPreview={() => (<div>test</div>)}
                                    >
                                        {it.name}
                                    </DragDrop.Item>
                                )
                            })
                        }
                    </div>
                </DragDrop.Container>
                <DragDrop.Container>
                    <div
                        style={{
                            marginBottom: "12px",
                            overflowY: "auto",
                            border: "1px solid #D2D8DE",
                            borderRadius: "5px",
                        }}
                    >
                        {
                            _.map(this.data, (it, index) => {
                                return (
                                    <DragDrop.Item
                                        key={it.key}
                                        move={this.onMove}
                                        index={index}
                                        style={{
                                            height: 39,
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "0 16px",
                                        }}
                                        group="2"
                                        renderPreview={() => (<div>test</div>)}
                                    >
                                        {it.name}
                                    </DragDrop.Item>
                                )
                            })
                        }
                    </div>
                </DragDrop.Container>
            </React.Fragment>
        )
    }
}
